export const REVIEW_DECISION = { APPROVE: 'APPROVE', REJECT: 'REJECT' } as const;

export const REVIEWER_COMMENT_MAX_LENGTH = 1000;
